import axios from 'axios';
import qs from 'qs';
import cookie from '../../cookieHelper/cookie'; // Assuming you have a cookie helper for managing cookies

const API_URL = process.env.REACT_APP_BASE_URL + '/api/v1/bulk/storyPublish';

export default function bulkPublish(data) {
    // Retrieve the authentication token from cookies
    const authToken = cookie.getCookie(process.env.REACT_APP_COOKIE_NAME);


    // Configuration object with authorization header
    const config = {
        headers: {
            Authorization: `Bearer ${authToken}`,
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    };

    return (
        axios.post(API_URL, qs.stringify(data), config)
        .then(res => {            
            // console.log("res: ", res);
            return res.data;
        })
        .catch(err => {
            // console.log("err: ", err);
            return err;
        })
    );
}
